import React from 'react';
import ReactDOM from "react-dom";
import Calendar from 'react-calendar';
import UserProfile from './userProfile';
import CustomerProfile from './customerProfile';
import 'react-calendar/dist/Calendar.css';
import Invoice from './invoice';
import Loader from './loader';

export default class History extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: null,
            error: null,
            isLoaded: false,
            isSubmitting: false,
            date: new Date(),
            date2: new Date(),
            history: []
        };
    }

    onChange = date => this.setState({ date })
    onChange2 = date2 => this.setState({ date2 })

    dateConvertISO(date) {
        var res;
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var dt = date.getDate();
        if (dt < 10) {
            dt = '0' + dt;
        }
        if (month < 10) {
            month = '0' + month;
        }
        res = year + '-' + month + '-' + dt;
        return res;
    }

    historySelectionGet() {
        var companyID = CustomerProfile.getCompanyID();
        var fromDate = this.dateConvertISO(this.state.date);
        var toDate = this.dateConvertISO(this.state.date2);
        var userID = UserProfile.getUserID();
        var uCompanyID = UserProfile.getCompanyID();
        var data = { event: 'history-get', fromDate: fromDate, upToDate: toDate, companyID: companyID, userID: userID, uCompanyID: uCompanyID };
        //var url = UserProfile.getURL() + '/invoice/ajax.php?event=history-get&fromDate=' + dateISO + '&upToDate=' + dateISO_2 + '&companyID=null' + '&userID=' + userID + '&uCompanyID=' + uCompanyID;
        var url = UserProfile.getURL() + '/invoice/ajax.php';
        fetch(url, {
            method: "POST",
            /*headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
              },*/
            body: new URLSearchParams(data),
            headers: new Headers({ 'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8' })
        })
            .then(res => {
                this.setState({ isSubmitting: false });
                return res.json();
            })
            .then(
                (result) => {
                    this.setState({
                        isLoaded: true,
                        history: result
                    });
                    //console.log(this.isLoaded);
                    //console.log(result);
                    this.historiListGet(result);
                },
                (error) => {
                    this.setState({
                        isLoaded: true,
                        error
                    });
                }
            )
    }

    invoicePrint(coInvoiceID) {
        new Invoice().historyInvoicePrint(coInvoiceID);
    }

    stornoPrint(coInvoiceID) {
        new Invoice().historyStornoPrint(coInvoiceID);
    }

    historiListGet(history) {
        ReactDOM.render(
            <Loader />, document.getElementById('invoiceBody')
        );
        var res = null;
        var cData = CustomerProfile.getCustomer();
        var companyID = CustomerProfile.getCompanyID();
        var title = '';
        if (companyID === 0) {
            title = <h1>{'Összes kiállított számla'}</h1>;
        } else {
            title = <h1>{cData.name + ' Ügyfél számlái'}</h1>;
            CustomerProfile.setCompanyID(0);
            CustomerProfile.setCustomer(0);
        }
        if (history !== null) {
            //console.log(history);
            res = history.map((item) =>
                <li key={item.invoiceID}>
                    {'Kelt: '}{item.wDate}
                    {' Számlaszám: '}{item.abbreviation}-{item.coInvoiceID}
                    {' Számla: '}{item.iType}
                    <p>
                        <a href='#' onClick={() => this.invoicePrint(item.coInvoiceID)}>
                            {'Nyomtat '}
                        </a>
                        <a href='#' onClick={() => this.stornoPrint(item.coInvoiceID)}>
                            {' Sztornó'}
                        </a>
                        <b>{item.sInvoiceID !== null && item.sCompanyID === UserProfile.getCompanyID() ? ' Sztornozva: ' + item.sDate + ' ' + item.abbreviation + '-' + item.sInvoiceID : ''}</b>
                    </p>
                </li>
            );
        } else {
            res = <li>{'Nincs megjeleníthetú elem!'}</li>
        }
        setTimeout(function () {
            ReactDOM.render(
                <div>{title}<ul>{res}</ul></div>, document.getElementById('invoiceBody')
            );
        }, 100);
    }

    render() {
        return (
            <div className='invoiceBody'>
                <h1>{'Számlázási időszak kiválasztása'}</h1>
                <div className='calendar'>
                    <div className='date'>
                        <h2>Dátumtól</h2>
                        <Calendar
                            onChange={this.onChange}
                            value={this.state.date}
                        />
                    </div>
                    <div className='date'>
                        <h2>Dátumig</h2>
                        <Calendar
                            onChange={this.onChange2}
                            value={this.state.date2}
                        />
                    </div>
                </div>
                <div>
                    <button className="push" onClick={() => this.historySelectionGet()}>
                        {this.props.value}
                    </button>
                </div>
            </div>
        );
    }

} 